let Photos1940=[
  {
    "NameEN": "1940",
    "Image": "un2",
    "CaptionEN": "British PM Clement Attlee at first UNGA meeting, 1946 [AP Photo]",
    "CaptionAR":"رئيس الوزراء البريطاني كلمنت أتلي خلال الاجتماع الأول للجمعية العامة عام 1946 (أسوشيتد برس)"
  },
  {
    "NameEN": null,
    "Image": "un4",
    "CaptionEN": "Eleanor Roosevelt was instrumental in formulating the Universal Declaration of Human Rights, 1948 [FPG/Getty Images]",
    "CaptionAR": "السيدة الأميركية الأولى إليانور فرانكلين روزفلت ساهمت بفعالية في صياغة الإعلان العالمي لحقوق الإنسان عام 1948 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un3",
    "CaptionEN": "Oswaldo Aranha, president of the UNGA, 1947. Aranha was a major supporter of the creation of the Israeli state [Getty images]",
    "CaptionAR": "رئيس الجمعية العامة للعام 1947 الدبلوماسي البرازيلي أوسوالدو أرانها كان أكبر الداعمين لإنشاء دولة إسرائيل (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un1",
    "CaptionEN": "Indian diplomat and first female president of the UNGA Vijaya Lakshmi Pandit, 1946 [Getty Images]",
    "CaptionAR": "الدبلوماسية الهندية فيجايا لاكشمي بانديت أول سيدة تترأس الجمعية العامة عام 1946 (غيتي)"
  }
]
export default Photos1940